export const bannersDual = {
  'Secretum Secretorum 2': [
    {
      name: 'Secretum Secretorum',
      image: 2,
      shortName: 'Albedo',
      start: '2021-11-24 06:00:00',
      end: '2021-12-14 17:59:59',
      color: '#FFFAF5',
      featured: ['albedo', 'eula'],
      featuredRare: ['rosaria', 'noelle', 'bennett'],
      timezoneDependent: true,
      version: '2.3',
    },
    {
      name: 'Born of Ocean Swell',
      image: 2,
      shortName: 'Eula',
      start: '2021-11-24 06:00:00',
      end: '2021-12-14 17:59:59',
      color: '#E7F9FF',
      featured: ['albedo', 'eula'],
      featuredRare: ['rosaria', 'noelle', 'bennett'],
      timezoneDependent: true,
      version: '2.3',
    },
  ],
  'The Transcendent One Returns 1': [
    {
      name: 'The Transcendent One Returns',
      image: 1,
      shortName: 'Shenhe',
      start: '2022-01-05 06:00:00',
      end: '2022-01-25 17:59:59',
      color: '#81DDF0',
      featured: ['shenhe', 'xiao'],
      featuredRare: ['yun_jin', 'ningguang', 'chongyun'],
      timezoneDependent: true,
      version: '2.4',
    },
    {
      name: 'Invitation to Mundane Life',
      image: 2,
      shortName: 'Xiao',
      start: '2022-01-05 06:00:00',
      end: '2022-01-25 17:59:59',
      color: '#25d7b8',
      featured: ['shenhe', 'xiao'],
      featuredRare: ['yun_jin', 'ningguang', 'chongyun'],
      timezoneDependent: true,
      version: '2.4',
    },
  ],
  'Gentry of Hermitage 3': [
    {
      name: 'Gentry of Hermitage',
      image: 3,
      shortName: 'Zhongli',
      start: '2022-01-25 18:00:00',
      end: '2022-02-15 14:59:59',
      color: '#FFF5BF',
      featured: ['zhongli', 'ganyu'],
      featuredRare: ['xingqiu', 'beidou', 'yanfei'],
      version: '2.4',
    },
    {
      name: 'Adrift in the Harbor',
      image: 2,
      shortName: 'Ganyu',
      start: '2022-01-25 18:00:00',
      end: '2022-02-15 14:59:59',
      color: '#FFF5BF',
      featured: ['zhongli', 'ganyu'],
      featuredRare: ['xingqiu', 'beidou', 'yanfei'],
      version: '2.4',
    },
  ],
  'Reign of Serenity 2': [
    {
      name: 'Reign of Serenity',
      image: 2,
      shortName: 'Raiden',
      start: '2022-03-08 18:00:00',
      end: '2022-03-29 14:59:59',
      color: '#D0AEF2',
      featured: ['raiden_shogun', 'sangonomiya_kokomi'],
      featuredRare: ['bennett', 'xinyan', 'kujou_sara'],
      version: '2.5',
    },
    {
      name: 'Drifting Luminescence',
      image: 2,
      shortName: 'Kokomi',
      start: '2022-03-08 18:00:00',
      end: '2022-03-29 14:59:59',
      color: '#53caf3',
      featured: ['raiden_shogun', 'sangonomiya_kokomi'],
      featuredRare: ['bennett', 'xinyan', 'kujou_sara'],
      version: '2.5',
    },
  ],
  'Azure Excursion 1': [
    {
      name: 'Azure Excursion',
      image: 1,
      shortName: 'Ayato',
      start: '2022-03-30 06:00:00',
      end: '2022-04-19 17:59:59',
      color: '#90bce9',
      featured: ['kamisato_ayato', 'venti'],
      featuredRare: ['yun_jin', 'xiangling', 'sucrose'],
      timezoneDependent: true,
      version: '2.6',
    },
    {
      name: 'Ballad in Goblets',
      image: 3,
      shortName: 'Venti',
      start: '2022-03-30 06:00:00',
      end: '2022-04-19 17:59:59',
      color: '#ffd1f9',
      featured: ['kamisato_ayato', 'venti'],
      featuredRare: ['yun_jin', 'xiangling', 'sucrose'],
      timezoneDependent: true,
      version: '2.6',
    },
  ],
  'Discerner of Enigmas 1': [
    {
      name: 'Discerner of Enigmas',
      image: 1,
      shortName: 'Yelan',
      start: '2022-05-31 09:00:00',
      end: '2022-06-21 17:59:59',
      color: '#7de6fd',
      featured: ['yelan', 'xiao'],
      featuredRare: ['barbara', 'noelle', 'yanfei'],
      timezoneDependent: true,
      version: '2.7',
    },
    {
      name: 'Invitation to Mundane Life',
      image: 3,
      shortName: 'Xiao',
      start: '2022-05-31 09:00:00',
      end: '2022-06-21 17:59:59',
      color: '#25d7b8',
      featured: ['yelan', 'xiao'],
      featuredRare: ['barbara', 'noelle', 'yanfei'],
      timezoneDependent: true,
      version: '2.7',
    },
  ],
  'Leaves in the Wind 2': [
    {
      name: 'Leaves in the Wind',
      image: 2,
      shortName: 'Kazuha',
      start: '2022-07-13 06:00:00',
      end: '2022-08-02 17:59:59',
      color: '#7edec3',
      featured: ['kaedehara_kazuha', 'klee'],
      featuredRare: ['ningguang', 'thoma', 'shikanoin_heizou'],
      timezoneDependent: true,
      version: '2.8',
    },
    {
      name: 'Sparkling Steps',
      image: 3,
      shortName: 'Klee',
      start: '2022-07-13 06:00:00',
      end: '2022-08-02 17:59:59',
      color: '#ff7763',
      featured: ['kaedehara_kazuha', 'klee'],
      featuredRare: ['ningguang', 'thoma', 'shikanoin_heizou'],
      timezoneDependent: true,
      version: '2.8',
    },
  ],
  'Viridescent Vigil 1': [
    {
      name: 'Viridescent Vigil',
      image: 1,
      shortName: 'Tighnari',
      start: '2022-08-24 06:00:00',
      end: '2022-09-09 17:59:59',
      color: '#76df81',
      featured: ['tighnari', 'zhongli'],
      featuredRare: ['collei', 'fischl', 'diona'],
      timezoneDependent: true,
      version: '3.0',
    },
    {
      name: 'Gentry of Hermitage',
      image: 4,
      shortName: 'Zhongli',
      start: '2022-08-24 06:00:00',
      end: '2022-09-09 17:59:59',
      color: '#D1A55C',
      featured: ['tighnari', 'zhongli'],
      featuredRare: ['collei', 'fischl', 'diona'],
      timezoneDependent: true,
      version: '3.0',
    },
  ],
  'Adrift in the Harbor 3': [
    {
      name: 'Adrift in the Harbor',
      image: 3,
      shortName: 'Ganyu',
      start: '2022-09-09 18:00:00',
      end: '2022-09-27 14:59:59',
      color: '#ceebf3',
      featured: ['ganyu', 'sangonomiya_kokomi'],
      featuredRare: ['xingqiu', 'sucrose', 'dori'],
      version: '3.0',
    },
    {
      name: 'Drifting Luminescence',
      image: 3,
      shortName: 'Kokomi',
      start: '2022-09-09 18:00:00',
      end: '2022-09-27 14:59:59',
      color: '#ceebf3',
      featured: ['ganyu', 'sangonomiya_kokomi'],
      featuredRare: ['xingqiu', 'sucrose', 'dori'],
      version: '3.0',
    },
  ],
  'Twilight Arbiter 1': [
    {
      name: 'Twilight Arbiter',
      image: 1,
      shortName: 'Cyno',
      start: '2022-09-28 06:00:00',
      end: '2022-10-14 17:59:59',
      color: '#d8b8f7',
      featured: ['cyno', 'venti'],
      featuredRare: ['sayu', 'candace', 'kuki_shinobu'],
      timezoneDependent: true,
      version: '3.1',
    },
    {
      name: 'Ballad in Goblets',
      image: 4,
      shortName: 'Venti',
      start: '2022-09-28 06:00:00',
      end: '2022-10-14 17:59:59',
      color: '#96f6de',
      featured: ['cyno', 'venti'],
      featuredRare: ['sayu', 'candace', 'kuki_shinobu'],
      timezoneDependent: true,
      version: '3.1',
    },
  ],
  'Twirling Lotus 1': [
    {
      name: 'Twirling Lotus',
      image: 1,
      shortName: 'Nilou',
      start: '2022-10-14 18:00:00',
      end: '2022-11-01 14:59:59',
      color: '#b2e0f0',
      featured: ['nilou', 'albedo'],
      featuredRare: ['barbara', 'xiangling', 'beidou'],
      version: '3.1',
    },
    {
      name: 'Secretum Secretorum',
      image: 3,
      shortName: 'Nilou',
      start: '2022-10-14 18:00:00',
      end: '2022-11-01 14:59:59',
      color: '#b2e0f0',
      featured: ['nilou', 'albedo'],
      featuredRare: ['barbara', 'xiangling', 'beidou'],
      version: '3.1',
    },
  ],
  "The Moongrass' Enlightenment 1": [
    {
      name: "The Moongrass' Enlightenment",
      image: 1,
      shortName: 'Nahida',
      start: '2022-11-02 06:00:00',
      end: '2022-11-18 17:59:59',
      color: '#d8b8f7',
      featured: ['nahida', 'yoimiya'],
      featuredRare: ['bennett', 'razor', 'noelle'],
      timezoneDependent: true,
      version: '3.2',
    },
    {
      name: 'Tapestry of Golden Flames',
      image: 3,
      shortName: 'Yoimiya',
      start: '2022-11-02 06:00:00',
      end: '2022-11-18 17:59:59',
      color: '#fc8976',
      featured: ['nahida', 'yoimiya'],
      featuredRare: ['bennett', 'razor', 'noelle'],
      timezoneDependent: true,
      version: '3.2',
    },
  ],
  'Everbloom Violet 2': [
    {
      name: 'Everbloom Violet',
      image: 2,
      shortName: 'Yae Miko',
      start: '2022-11-18 18:00:00',
      end: '2022-12-06 14:59:59',
      color: '#ffd1f9',
      featured: ['yae_miko', 'tartaglia'],
      featuredRare: ['thoma', 'shikanoin_heizou', 'layla'],
      version: '3.2',
    },
    {
      name: 'Farewell of Snezhnaya',
      image: 4,
      shortName: 'Tartaglia',
      start: '2022-11-18 18:00:00',
      end: '2022-12-06 14:59:59',
      color: '#4ED8F3',
      featured: ['yae_miko', 'tartaglia'],
      featuredRare: ['thoma', 'shikanoin_heizou', 'layla'],
      version: '3.2',
    },
  ],
  'From Ashes Reborn 1': [
    {
      name: 'From Ashes Reborn',
      image: 1,
      shortName: 'Wanderer',
      start: '2022-12-07 06:00:00',
      end: '2022-12-27 17:59:59',
      color: '#31cae1',
      featured: ['wanderer', 'arataki_itto'],
      featuredRare: ['faruzan', 'yanfei', 'gorou'],
      timezoneDependent: true,
      version: '3.3',
    },
    {
      name: "Oni's Royale",
      image: 3,
      shortName: 'Itto',
      start: '2022-12-07 06:00:00',
      end: '2022-12-27 17:59:59',
      color: '#FFB455',
      featured: ['wanderer', 'arataki_itto'],
      featuredRare: ['faruzan', 'yanfei', 'gorou'],
      timezoneDependent: true,
      version: '3.3',
    },
  ],
  'Reign of Serenity 3': [
    {
      name: 'Reign of Serenity',
      image: 3,
      shortName: 'Raiden',
      start: '2022-12-27 18:00:00',
      end: '2023-01-17 14:59:59',
      color: '#D0AEF2',
      featured: ['raiden_shogun', 'kamisato_ayato'],
      featuredRare: ['sayu', 'rosaria', 'kujou_sara'],
      version: '3.3',
    },
    {
      name: 'Azure Excursion',
      image: 2,
      shortName: 'Ayato',
      start: '2022-12-27 18:00:00',
      end: '2023-01-17 14:59:59',
      color: '#90bce9',
      featured: ['raiden_shogun', 'kamisato_ayato'],
      featuredRare: ['sayu', 'rosaria', 'kujou_sara'],
      version: '3.3',
    },
  ],
  'Caution in Confidence 1': [
    {
      name: 'Caution in Confidence',
      image: 1,
      shortName: 'Alhaitham',
      start: '2023-01-18 06:00:00',
      end: '2023-02-07 17:59:59',
      color: '#5bcbd1',
      featured: ['alhaitham', 'xiao'],
      featuredRare: ['xinyan', 'yun_jin', 'yaoyao'],
      timezoneDependent: true,
      version: '3.4',
    },
    {
      name: 'Invitation to Mundane Life',
      image: 4,
      shortName: 'Xiao',
      start: '2023-01-18 06:00:00',
      end: '2023-02-07 17:59:59',
      color: '#25d7b8',
      featured: ['alhaitham', 'xiao'],
      featuredRare: ['xinyan', 'yun_jin', 'yaoyao'],
      timezoneDependent: true,
      version: '3.4',
    },
  ],
  'Moment of Bloom 3': [
    {
      name: 'Moment of Bloom',
      image: 3,
      shortName: 'Hu Tao',
      start: '2023-02-07 18:00:00',
      end: '2023-02-28 14:59:59',
      color: '#FF7966',
      featured: ['hu_tao', 'yelan'],
      featuredRare: ['beidou', 'ningguang', 'xingqiu'],
      version: '3.4',
    },
    {
      name: 'Discerner of Enigmas',
      image: 2,
      shortName: 'Yelan',
      start: '2023-02-07 18:00:00',
      end: '2023-02-28 14:59:59',
      color: '#7de6fd',
      featured: ['hu_tao', 'yelan'],
      featuredRare: ['beidou', 'ningguang', 'xingqiu'],
      version: '3.4',
    },
  ],
  'Auric Blaze 1': [
    {
      name: 'Auric Blaze',
      image: 1,
      shortName: 'Dehya',
      start: '2023-03-01 06:00:00',
      end: '2023-03-21 17:59:59',
      color: '#FF7966',
      featured: ['dehya', 'cyno'],
      featuredRare: ['bennett', 'collei', 'barbara'],
      timezoneDependent: true,
      version: '3.5',
    },
    {
      name: 'Twilight Arbiter',
      image: 2,
      shortName: 'Cyno',
      start: '2023-03-01 06:00:00',
      end: '2023-03-21 17:59:59',
      color: '#FF7966',
      featured: ['dehya', 'cyno'],
      featuredRare: ['bennett', 'collei', 'barbara'],
      timezoneDependent: true,
      version: '3.5',
    },
  ],
  'The Transcendent One Returns 2': [
    {
      name: 'The Transcendent One Returns',
      image: 2,
      shortName: 'Shenhe',
      start: '2023-03-21 18:00:00',
      end: '2023-04-11 14:59:59',
      color: '#81DDF0',
      featured: ['shenhe', 'kamisato_ayaka'],
      featuredRare: ['diona', 'sucrose', 'mika'],
      version: '3.5',
    },
    {
      name: 'The Herons Court',
      image: 3,
      shortName: 'Shenhe',
      start: '2023-03-21 18:00:00',
      end: '2023-04-11 14:59:59',
      color: '#FFFBF7',
      featured: ['shenhe', 'kamisato_ayaka'],
      featuredRare: ['diona', 'sucrose', 'mika'],
      version: '3.5',
    },
  ],
  "The Moongrass' Enlightenment 2": [
    {
      name: "The Moongrass' Enlightenment",
      image: 2,
      shortName: 'Nahida',
      start: '2023-04-12 06:00:00',
      end: '2023-05-02 17:59:59',
      color: '#b8db94',
      featured: ['nahida', 'nilou'],
      featuredRare: ['kuki_shinobu', 'dori', 'layla'],
      timezoneDependent: true,
      version: '3.6',
    },
    {
      name: 'Twirling Lotus',
      image: 2,
      shortName: 'Nilou',
      start: '2023-04-12 06:00:00',
      end: '2023-05-02 17:59:59',
      color: '#b2e0f0',
      featured: ['nahida', 'nilou'],
      featuredRare: ['kuki_shinobu', 'dori', 'layla'],
      timezoneDependent: true,
      version: '3.6',
    },
  ],
  'Immaculate Pulse 1': [
    {
      name: 'Immaculate Pulse',
      image: 1,
      shortName: 'Baizhu',
      start: '2023-05-02 18:00:00',
      end: '2023-05-23 14:59:59',
      color: '#8fdaa0',
      featured: ['baizhu', 'ganyu'],
      featuredRare: ['kaveh', 'candace', 'fischl'],
      version: '3.6',
    },
    {
      name: 'Adrift in the Harbor',
      image: 4,
      shortName: 'Ganyu',
      start: '2023-05-02 18:00:00',
      end: '2023-05-23 14:59:59',
      color: '#6994DF',
      featured: ['baizhu', 'ganyu'],
      featuredRare: ['kaveh', 'candace', 'fischl'],
      version: '3.6',
    },
  ],
  'Tapestry of Golden Flames 4': [
    {
      name: 'Tapestry of Golden Flames',
      image: 4,
      shortName: 'Yoimiya',
      start: '2023-05-24 06:00:00',
      end: '2023-06-13 17:59:59',
      color: '#fc8976',
      featured: ['yoimiya', 'yae_miko'],
      featuredRare: ['kirara', 'yun_jin', 'chongyun'],
      timezoneDependent: true,
      version: '3.7',
    },
    {
      name: 'Everbloom Violet',
      image: 3,
      shortName: 'Yae Miko',
      start: '2023-05-24 06:00:00',
      end: '2023-06-13 17:59:59',
      color: '#ffd1f9',
      featured: ['yoimiya', 'yae_miko'],
      featuredRare: ['kirara', 'yun_jin', 'chongyun'],
      timezoneDependent: true,
      version: '3.7',
    },
  ],
  'Caution in Confidence 2': [
    {
      name: 'Caution in Confidence',
      image: 2,
      shortName: 'Alhaitham',
      start: '2023-06-13 18:00:00',
      end: '2023-07-04 14:59:59',
      color: '#5bcbd1',
      featured: ['alhaitham', 'kaedehara_kazuha'],
      featuredRare: ['yaoyao', 'shikanoin_heizou', 'xiangling'],
      version: '3.7',
    },
    {
      name: 'Leaves in the Wind',
      image: 3,
      shortName: 'Kazuha',
      start: '2023-06-13 18:00:00',
      end: '2023-07-04 14:59:59',
      color: '#5bcbd1',
      featured: ['alhaitham', 'kaedehara_kazuha'],
      featuredRare: ['yaoyao', 'shikanoin_heizou', 'xiangling'],
      version: '3.7',
    },
  ],
  'Born of Ocean Swell 3': [
    {
      name: 'Born of Ocean Swell',
      image: 3,
      shortName: 'Eula',
      start: '2023-07-05 06:00:00',
      end: '2023-07-25 17:59:59',
      color: '#A6D6E0',
      featured: ['eula', 'klee'],
      featuredRare: ['mika', 'razor', 'thoma'],
      timezoneDependent: true,
      version: '3.8',
    },
    {
      name: 'Sparkling Steps',
      image: 4,
      shortName: 'Klee',
      start: '2023-07-05 06:00:00',
      end: '2023-07-25 17:59:59',
      color: '#A6D6E0',
      featured: ['eula', 'klee'],
      featuredRare: ['mika', 'razor', 'thoma'],
      timezoneDependent: true,
      version: '3.8',
    },
  ],
  'Drifting Luminescence 4': [
    {
      name: 'Drifting Luminescence',
      image: 4,
      shortName: 'Kokomi',
      start: '2023-07-25 18:00:00',
      end: '2023-08-15 17:59:59',
      color: '#53caf3',
      featured: ['sangonomiya_kokomi', 'wanderer'],
      featuredRare: ['yanfei', 'faruzan', 'rosaria'],
      version: '3.8',
    },
    {
      name: 'From Ashes Reborn',
      image: 2,
      shortName: 'Wanderer',
      start: '2023-07-25 18:00:00',
      end: '2023-08-15 17:59:59',
      color: '#53caf3',
      featured: ['sangonomiya_kokomi', 'wanderer'],
      featuredRare: ['yanfei', 'faruzan', 'rosaria'],
      version: '3.8',
    },
  ],
  'Conjuring Chiaroscuro 1': [
    {
      name: 'Conjuring Chiaroscuro',
      image: 1,
      shortName: 'Lyney',
      start: '2023-08-16 06:00:00',
      end: '2023-09-05 17:59:59',
      color: '#fcc6c8',
      featured: ['lyney', 'yelan'],
      featuredRare: ['bennett', 'barbara', 'lynette'],
      version: '4.0',
      timezoneDependent: true,
    },
    {
      name: 'Discerner of Enigmas',
      image: 3,
      shortName: 'Yelan',
      start: '2023-08-16 06:00:00',
      end: '2023-09-05 17:59:59',
      color: '#fcc6c8',
      featured: ['lyney', 'yelan'],
      featuredRare: ['bennett', 'barbara', 'lynette'],
      version: '4.0',
      timezoneDependent: true,
    },
  ],
  'Gentry of Hermitage 5': [
    {
      name: 'Gentry of Hermitage',
      image: 5,
      shortName: 'Zhongli',
      start: '2023-09-05 18:00:00',
      end: '2023-09-26 14:59:59',
      color: '#D1A55C',
      featured: ['tartaglia', 'zhongli'],
      featuredRare: ['freminet', 'sayu', 'noelle'],
      version: '4.0',
    },
    {
      name: 'Farewell of Snezhnaya',
      image: 5,
      shortName: 'Tartaglia',
      start: '2023-09-05 18:00:00',
      end: '2023-09-26 14:59:59',
      color: '#4ED8F3',
      featured: ['tartaglia', 'zhongli'],
      featuredRare: ['freminet', 'sayu', 'noelle'],
      version: '4.0',
    },
  ],
  'Decree of the Deeps 1': [
    {
      name: 'Decree of the Deeps',
      image: 1,
      shortName: 'Neuvillette',
      start: '2023-09-27 06:00:00',
      end: '2023-10-17 17:59:59',
      color: '#D1A55C',
      featured: ['neuvillette', 'hu_tao'],
      featuredRare: ['fischl', 'xingqiu', 'diona'],
      version: '4.1',
      timezoneDependent: true,
    },
    {
      name: 'Moment of Bloom',
      image: 4,
      shortName: 'Hu Tao',
      start: '2023-09-27 06:00:00',
      end: '2023-10-17 17:59:59',
      color: '#FF7966',
      featured: ['neuvillette', 'hu_tao'],
      featuredRare: ['fischl', 'xingqiu', 'diona'],
      version: '4.1',
      timezoneDependent: true,
    },
  ],
  'Tempestuous Destiny 1': [
    {
      name: 'Tempestuous Destiny',
      image: 1,
      shortName: 'Wriothesley',
      start: '2023-10-17 18:00:00',
      end: '2023-11-07 14:59:59',
      color: '#b3d7f1',
      featured: ['wriothesley', 'venti'],
      featuredRare: ['chongyun', 'thoma', 'dori'],
      version: '4.1',
    },
    {
      name: 'Ballad in Goblets',
      image: 5,
      shortName: 'Venti',
      start: '2023-10-17 18:00:00',
      end: '2023-11-07 14:59:59',
      color: '#96f6de',
      featured: ['wriothesley', 'venti'],
      featuredRare: ['chongyun', 'thoma', 'dori'],
      version: '4.1',
    },
  ],
  'Chanson of Many Waters 1': [
    {
      name: 'Chanson of Many Waters',
      image: 1,
      shortName: 'Furina',
      start: '2023-11-08 06:00:00',
      end: '2023-11-28 17:59:59',
      color: '#95d6fb',
      featured: ['furina', 'baizhu'],
      featuredRare: ['charlotte', 'collei', 'beidou'],
      version: '4.2',
      timezoneDependent: true,
    },
    {
      name: 'Immaculate Pulse',
      image: 2,
      shortName: 'Baizhu',
      start: '2023-11-08 06:00:00',
      end: '2023-11-28 17:59:59',
      color: '#8fdaa0',
      featured: ['furina', 'baizhu'],
      featuredRare: ['charlotte', 'collei', 'beidou'],
      version: '4.2',
      timezoneDependent: true,
    },
  ],
  'Twilight Arbiter 3': [
    {
      name: 'Twilight Arbiter',
      image: 3,
      shortName: 'Cyno',
      start: '2023-11-28 18:00:00',
      end: '2023-12-19 14:59:59',
      color: '#d8b8f7',
      featured: ['cyno', 'kamisato_ayato'],
      featuredRare: ['kuki_shinobu', 'xiangling', 'kirara'],
      version: '4.2',
    },
    {
      name: 'Azure Excursion',
      image: 3,
      shortName: 'Ayato',
      start: '2023-11-28 18:00:00',
      end: '2023-12-19 14:59:59',
      color: '#90bce9',
      featured: ['cyno', 'kamisato_ayato'],
      featuredRare: ['kuki_shinobu', 'xiangling', 'kirara'],
      version: '4.2',
    },
  ],
  'In the Name of the Rosula 1': [
    {
      name: 'In the Name of the Rosula',
      image: 1,
      shortName: 'Navia',
      start: '2023-12-20 06:00:00',
      end: '2024-01-09 17:59:59',
      color: '#f6e195',
      featured: ['navia', 'kamisato_ayaka'],
      featuredRare: ['sucrose', 'candace', 'rosaria'],
      version: '4.3',
      timezoneDependent: true,
    },
    {
      name: "The Heron's Court",
      image: 4,
      shortName: 'Ayaka',
      start: '2023-12-20 06:00:00',
      end: '2024-01-09 17:59:59',
      color: '#f6e195',
      featured: ['navia', 'kamisato_ayaka'],
      featuredRare: ['sucrose', 'candace', 'rosaria'],
      version: '4.3',
      timezoneDependent: true,
    },
  ],
  'Reign of Serenity 4': [
    {
      name: 'Reign of Serenity',
      image: 4,
      shortName: 'Raiden',
      start: '2024-01-09 18:00:00',
      end: '2024-01-30 14:59:00',
      color: '#D0AEF2',
      featured: ['raiden_shogun', 'yoimiya'],
      featuredRare: ['bennett', 'kujou_sara', 'chevreuse'],
      version: '4.3',
    },
    {
      name: 'Tapestry of Golden Flames',
      image: 5,
      shortName: 'Yoimiya',
      start: '2024-01-09 18:00:00',
      end: '2024-01-30 14:59:00',
      color: '#D0AEF2',
      featured: ['raiden_shogun', 'yoimiya'],
      featuredRare: ['bennett', 'kujou_sara', 'chevreuse'],
      version: '4.3',
    },
  ],
  'The Crane Soars Skyward 1': [
    {
      name: 'The Crane Soars Skyward',
      image: 1,
      shortName: 'Xianyun',
      start: '2024-01-31 06:00:00',
      end: '2024-02-20 17:59:00',
      color: '#affcd1',
      featured: ['xianyun', 'nahida'],
      featuredRare: ['gaming', 'faruzan', 'noelle'],
      version: '4.4',
      timezoneDependent: true,
    },
    {
      name: "The Moongrass' Enlightenment",
      image: 3,
      shortName: 'Nahida',
      start: '2024-01-31 06:00:00',
      end: '2024-02-20 17:59:00',
      color: '#b8db94',
      featured: ['xianyun', 'nahida'],
      featuredRare: ['gaming', 'faruzan', 'noelle'],
      version: '4.4',
      timezoneDependent: true,
    },
  ],
  'Invitation to Mundane Life 5': [
    {
      name: 'Invitation to Mundane Life',
      image: 5,
      shortName: 'Xiao',
      start: '2024-02-20 18:00:00',
      end: '2024-03-12 14:59:00',
      color: '#25d7b8',
      featured: ['xiao', 'yae_miko'],
      featuredRare: ['yaoyao', 'xinyan', 'ningguang'],
      version: '4.4',
    },
    {
      name: 'Everbloom Violet',
      image: 4,
      shortName: 'Yae',
      start: '2024-02-20 18:00:00',
      end: '2024-03-12 14:59:00',
      color: '#ffd1f9',
      featured: ['xiao', 'yae_miko'],
      featuredRare: ['yaoyao', 'xinyan', 'ningguang'],
      version: '4.4',
    },
  ],
  'Of Silken Clouds Woven 1': [
    {
      name: 'Of Silken Clouds Woven',
      image: 1,
      shortName: 'Chiori',
      start: '2024-03-13 06:00:00',
      end: '2024-04-02 17:59:00',
      color: '#ffbd34',
      featured: ['chiori', 'arataki_itto'],
      featuredRare: ['yun_jin', 'gorou', 'dori'],
      version: '4.5',
      timezoneDependent: true,
    },
    {
      name: "Oni's Royale",
      image: 4,
      shortName: 'Itto',
      start: '2024-03-13 06:00:00',
      end: '2024-04-02 17:59:00',
      color: '#ffb354',
      featured: ['chiori', 'arataki_itto'],
      featuredRare: ['yun_jin', 'gorou', 'dori'],
      version: '4.5',
      timezoneDependent: true,
    },
  ],
  'Decree of the Deeps 2': [
    {
      name: 'Decree of the Deeps',
      image: 2,
      shortName: 'Neuvillette',
      start: '2024-04-02 18:00:00',
      end: '2024-04-23 14:59:00',
      color: '#72fefd',
      featured: ['neuvillette', 'kaedehara_kazuha'],
      featuredRare: ['barbara', 'xingqiu', 'yanfei'],
      version: '4.5',
    },
    {
      name: 'Leaves in the Wind',
      image: 4,
      shortName: 'Kazuha',
      start: '2024-04-02 18:00:00',
      end: '2024-04-23 14:59:00',
      color: '#8FFFDE',
      featured: ['neuvillette', 'kaedehara_kazuha'],
      featuredRare: ['barbara', 'xingqiu', 'yanfei'],
      version: '4.5',
    },
  ],
  "The Hearth's Ashen Shadow 1": [
    {
      name: "The Hearth's Ashen Shadow",
      image: 1,
      shortName: 'Arlecchino',
      start: '2024-04-24 06:00:00',
      end: '2024-05-14 17:59:00',
      color: '#f8f8f8',
      featured: ['arlecchino', 'lyney'],
      featuredRare: ['freminet', 'lynette', 'xiangling'],
      version: '4.6',
      timezoneDependent: true,
    },
    {
      name: 'Conjuring Chiaroscuro',
      image: 2,
      shortName: 'Lyney',
      start: '2024-04-24 06:00:00',
      end: '2024-05-14 17:59:00',
      color: '#fcc6c8',
      featured: ['arlecchino', 'lyney'],
      featuredRare: ['freminet', 'lynette', 'xiangling'],
      version: '4.6',
      timezoneDependent: true,
    },
  ],
  'From Ashes Reborn 3': [
    {
      name: 'From Ashes Reborn',
      image: 3,
      shortName: 'Wanderer',
      start: '2024-05-14 18:00:00',
      end: '2024-06-04 14:59:00',
      color: '#31cae1',
      featured: ['wanderer', 'baizhu'],
      featuredRare: ['layla', 'faruzan', 'beidou'],
      version: '4.6',
    },
    {
      name: 'Immaculate Pulse',
      image: 3,
      shortName: 'Baizhu',
      start: '2024-05-14 18:00:00',
      end: '2024-06-04 14:59:00',
      color: '#8fdaa0',
      featured: ['wanderer', 'baizhu'],
      featuredRare: ['layla', 'faruzan', 'beidou'],
      version: '4.6',
    },
  ],
  'Illuminating Lightning 1': [
    {
      name: 'Illuminating Lightning',
      image: 1,
      shortName: 'Clorinde',
      start: '2024-06-05 06:00:00',
      end: '2024-06-25 17:59:00',
      color: '#6968ff',
      featured: ['clorinde', 'alhaitham'],
      featuredRare: ['sethos', 'bennett', 'thoma'],
      version: '4.7',
      timezoneDependent: true,
    },
    {
      name: 'Caution in Confidence',
      image: 3,
      shortName: 'Alhaitham',
      start: '2024-06-05 06:00:00',
      end: '2024-06-25 17:59:00',
      color: '#5bcbd1',
      featured: ['clorinde', 'alhaitham'],
      featuredRare: ['sethos', 'bennett', 'thoma'],
      version: '4.7',
      timezoneDependent: true,
    },
  ],
  'Romaritime Meluserenity 1': [
    {
      name: 'Romaritime Meluserenity',
      image: 1,
      shortName: 'Sigewinne',
      start: '2024-06-25 18:00:00',
      end: '2024-07-16 14:59:00',
      color: '#fadbf8',
      featured: ['sigewinne', 'furina'],
      featuredRare: ['noelle', 'gaming', 'rosaria'],
      version: '4.7',
    },
    {
      name: 'Chanson of Many Waters',
      image: 2,
      shortName: 'Furina',
      start: '2024-06-25 18:00:00',
      end: '2024-07-16 14:59:00',
      color: '#95d6fb',
      featured: ['sigewinne', 'furina'],
      featuredRare: ['noelle', 'gaming', 'rosaria'],
      version: '4.7',
    },
  ],
  'In the Name of the Rosula 2': [
    {
      name: 'In the Name of the Rosula',
      image: 2,
      shortName: 'Navia',
      start: '2024-07-17 06:00:00',
      end: '2024-08-06 17:59:00',
      color: '#fadbf8',
      featured: ['navia', 'nilou'],
      featuredRare: ['kirara', 'kaveh', 'ningguang'],
      version: '4.8',
      timezoneDependent: true,
    },
    {
      name: 'Twirling Lotus',
      image: 3,
      shortName: 'Nilou',
      start: '2024-07-17 06:00:00',
      end: '2024-08-06 17:59:00',
      color: '#b2e0f0',
      featured: ['navia', 'nilou'],
      featuredRare: ['kirara', 'kaveh', 'ningguang'],
      version: '4.8',
      timezoneDependent: true,
    },
  ],
  'Ambrosial Essence 1': [
    {
      name: 'Ambrosial Essence',
      image: 1,
      shortName: 'Emilie',
      start: '2024-08-06 18:00:00',
      end: '2024-08-27 14:59:00',
      color: '#cde8a4',
      featured: ['emilie', 'yelan'],
      featuredRare: ['yanfei', 'xiangling', 'razor'],
      version: '4.8',
    },
    {
      name: 'Discerner of Enigmas',
      image: 4,
      shortName: 'Yelan',
      start: '2024-08-06 18:00:00',
      end: '2024-08-27 14:59:00',
      color: '#7de6fd',
      featured: ['emilie', 'yelan'],
      featuredRare: ['yanfei', 'xiangling', 'razor'],
      version: '4.8',
    },
  ],
  'Sharktacular Surfari 1': [
    {
      name: 'Sharktacular Surfari',
      image: 1,
      shortName: 'Mualani',
      start: '2024-08-28 06:00:00',
      end: '2024-09-17 17:59:00',
      color: '#6fc5e2',
      featured: ['mualani', 'kaedehara_kazuha'],
      featuredRare: ['kachina', 'xinyan', 'bennett'],
      version: '5.0',
      timezoneDependent: true,
    },
    {
      name: 'Leaves in the Wind',
      image: 5,
      shortName: 'Kazuha',
      start: '2024-08-28 06:00:00',
      end: '2024-09-17 17:59:00',
      color: '#8FFFDE',
      featured: ['mualani', 'kaedehara_kazuha'],
      featuredRare: ['kachina', 'xinyan', 'bennett'],
      version: '5.0',
      timezoneDependent: true,
    },
  ],
  'Seeker of Flame-Wrought Secrets 1': [
    {
      name: 'Seeker of Flame-Wrought Secrets',
      image: 1,
      shortName: 'Kinich',
      start: '2024-09-17 18:00:00',
      end: '2024-10-08 14:59:00',
      color: '#53dcb9',
      featured: ['kinich', 'raiden_shogun'],
      featuredRare: ['thoma', 'kujou_sara', 'chevreuse'],
      version: '5.0',
    },
    {
      name: 'Reign of Serenity',
      image: 5,
      shortName: 'Raiden',
      start: '2024-09-17 18:00:00',
      end: '2024-10-08 14:59:00',
      color: '#53dcb9',
      featured: ['kinich', 'raiden_shogun'],
      featuredRare: ['thoma', 'kujou_sara', 'chevreuse'],
      version: '5.0',
    },
  ],
  "Forgefire's Blessing 1": [
    {
      name: "Forgefire's Blessing",
      image: 1,
      shortName: 'Xilonen',
      start: '2024-10-09 06:00:00',
      end: '2024-10-29 17:59:00',
      color: '#fae3a4',
      featured: ['xilonen', 'chiori'],
      featuredRare: ['dori', 'candace', 'collei'],
      version: '5.1',
      timezoneDependent: true,
    },
    {
      name: 'Of Silken Clouds Woven',
      image: 2,
      shortName: 'Chiori',
      start: '2024-10-09 06:00:00',
      end: '2024-10-29 17:59:00',
      color: '#ffbd34',
      featured: ['xilonen', 'chiori'],
      featuredRare: ['dori', 'candace', 'collei'],
      version: '5.1',
      timezoneDependent: true,
    },
  ],
  "The Moongrass' Enlightenment 4": [
    {
      name: "The Moongrass' Enlightenment",
      image: 4,
      shortName: 'Nahida',
      start: '2024-10-29 18:00:00',
      end: '2024-11-19 14:59:00',
      color: '#b8db94',
      featured: ['nahida', 'hu_tao'],
      featuredRare: ['sethos', 'xingqiu', 'kuki_shinobu'],
      version: '5.1',
    },
    {
      name: 'Moment of Bloom',
      image: 5,
      shortName: 'Hu Tao',
      start: '2024-10-29 18:00:00',
      end: '2024-11-19 14:59:00',
      color: '#c66051',
      featured: ['nahida', 'hu_tao'],
      featuredRare: ['sethos', 'xingqiu', 'kuki_shinobu'],
      version: '5.1',
    },
  ],
  "Piercing Shot's Crimson Wake 1": [
    {
      name: "Piercing Shot's Crimson Wake",
      image: 1,
      shortName: 'Chasca',
      start: '2024-11-20 06:00:00',
      end: '2024-12-10 17:59:00',
      color: '#fe7391',
      featured: ['chasca', 'lyney'],
      featuredRare: ['ororon', 'sucrose', 'barbara'],
      version: '5.2',
      timezoneDependent: true,
    },
    {
      name: 'Conjuring Chiaroscuro',
      image: 3,
      shortName: 'Lyney',
      start: '2024-11-20 06:00:00',
      end: '2024-12-10 17:59:00',
      color: '#fcc6c8',
      featured: ['chasca', 'lyney'],
      featuredRare: ['ororon', 'sucrose', 'barbara'],
      version: '5.2',
      timezoneDependent: true,
    },
  ],
  'Decree of the Deeps 3': [
    {
      name: 'Decree of the Deeps',
      image: 3,
      shortName: 'Neuvillette',
      start: '2024-12-10 18:00:00',
      end: '2024-12-31 14:59:00',
      color: '#72fefd',
      featured: ['neuvillette', 'zhongli'],
      featuredRare: ['shikanoin_heizou', 'fischl', 'yaoyao'],
      version: '5.2',
    },
    {
      name: 'Gentry of Hermitage',
      image: 6,
      shortName: 'Zhongli',
      start: '2024-12-10 18:00:00',
      end: '2024-12-31 14:59:00',
      color: '#D1A55C',
      featured: ['neuvillette', 'zhongli'],
      featuredRare: ['shikanoin_heizou', 'fischl', 'yaoyao'],
      version: '5.2',
    },
  ],
  'Ancient Flame Ablaze 1': [
    {
      name: 'Ancient Flame Ablaze',
      image: 1,
      shortName: 'Mavuika',
      start: '2025-01-01 06:00:00',
      end: '2025-01-21 17:59:00',
      color: '#ff6b37',
      featured: ['mavuika', 'citlali'],
      featuredRare: ['kachina', 'bennett', 'diona'],
      version: '5.3',
      timezoneDependent: true,
    },
    {
      name: "Starry Night's Whispers",
      image: 1,
      shortName: 'Citlali',
      start: '2025-01-01 06:00:00',
      end: '2025-01-21 17:59:00',
      color: '#efcbe5',
      featured: ['mavuika', 'citlali'],
      featuredRare: ['kachina', 'bennett', 'diona'],
      version: '5.3',
      timezoneDependent: true,
    },
  ],
  "The Hearth's Ashen Shadow 2": [
    {
      name: "The Hearth's Ashen Shadow",
      image: 2,
      shortName: 'Arlecchino',
      start: '2025-01-21 18:00:00',
      end: '2025-02-11 14:59:00',
      color: '#f8f8f8',
      featured: ['arlecchino', 'clorinde'],
      featuredRare: ['lan_yan', 'chevreuse', 'rosaria'],
      version: '5.3',
    },
    {
      name: 'Illuminating Lightning',
      image: 2,
      shortName: 'Clorinde',
      start: '2025-01-21 18:00:00',
      end: '2025-02-11 14:59:00',
      color: '#6968ff',
      featured: ['arlecchino', 'clorinde'],
      featuredRare: ['lan_yan', 'chevreuse', 'rosaria'],
      version: '5.3',
    },
  ],
  "Dawn's Drifting Reverie 1": [
    {
      name: "Dawn's Drifting Reverie",
      image: 1,
      shortName: 'Mizuki',
      start: '2025-02-12 06:00:00',
      end: '2025-03-04 17:59:00',
      color: '#f8f8f8',
      featured: ['yumemizuki_mizuki', 'sigewinne'],
      featuredRare: ['gorou', 'sayu', 'xiangling'],
      version: '5.4',
      timezoneDependent: true,
    },
    {
      name: 'Romaritime Meluserenity',
      image: 2,
      shortName: 'Sigewinne',
      start: '2025-02-12 06:00:00',
      end: '2025-03-04 17:59:00',
      color: '#fadbf8',
      featured: ['yumemizuki_mizuki', 'sigewinne'],
      featuredRare: ['gorou', 'sayu', 'xiangling'],
      version: '5.4',
      timezoneDependent: true,
    },
  ],
  'Tempestuous Destiny 2': [
    {
      name: 'Tempestuous Destiny',
      image: 2,
      shortName: 'Wriothesley',
      start: '2025-03-04 18:00:00',
      end: '2025-03-25 14:59:00',
      color: '#b3d7f1',
      featured: ['wriothesley', 'furina'],
      featuredRare: ['charlotte', 'chongyun', 'mika'],
      version: '5.4',
    },
    {
      name: 'Chanson of Many Waters',
      image: 3,
      shortName: 'Furina',
      start: '2025-03-04 18:00:00',
      end: '2025-03-25 14:59:00',
      color: '#95d6fb',
      featured: ['wriothesley', 'furina'],
      featuredRare: ['charlotte', 'chongyun', 'mika'],
      version: '5.4',
    },
  ],
  'Cornucopia of Contention 1': [
    {
      name: 'Cornucopia of Contention',
      image: 1,
      shortName: 'Varesa',
      start: '2025-03-26 06:00:00',
      end: '2025-04-15 17:59:00',
      color: '#ffa3af',
      featured: ['varesa', 'xianyun'],
      featuredRare: ['iansan', 'chevreuse', 'gaming'],
      version: '5.5',
      timezoneDependent: true,
    },
    {
      name: 'The Crane Soars Skyward',
      image: 2,
      shortName: 'Xianyun',
      start: '2025-03-26 06:00:00',
      end: '2025-04-15 17:59:00',
      color: '#affcd1',
      featured: ['varesa', 'xianyun'],
      featuredRare: ['iansan', 'chevreuse', 'gaming'],
      version: '5.5',
      timezoneDependent: true,
    },
  ],
  "Forgefire's Blessing 2": [
    {
      name: "Forgefire's Blessing",
      image: 2,
      shortName: 'Xilonen',
      start: '2025-04-15 18:00:00',
      end: '2025-05-06 14:59:00',
      color: '#fae3a4',
      featured: ['xilonen', 'venti'],
      featuredRare: ['faruzan', 'beidou', 'yanfei'],
      version: '5.5',
    },
    {
      name: 'Ballad in Goblets',
      image: 6,
      shortName: 'Xilonen',
      start: '2025-04-15 18:00:00',
      end: '2025-05-06 14:59:00',
      color: '#96f6de',
      featured: ['xilonen', 'venti'],
      featuredRare: ['faruzan', 'beidou', 'yanfei'],
      version: '5.5',
    },
  ],
  'La Chanson Cerise 1': [
    {
      name: 'La Chanson Cerise',
      image: 1,
      shortName: 'Escoffier',
      start: '2025-05-07 06:00:00',
      end: '2025-05-27 17:59:00',
      color: '#7af8fd',
      featured: ['escoffier', 'navia'],
      featuredRare: ['ifa', 'ororon', 'layla'],
      version: '5.6',
      timezoneDependent: true,
    },
    {
      name: 'In the Name of the Rosula',
      image: 3,
      shortName: 'Navia',
      start: '2025-05-07 06:00:00',
      end: '2025-05-27 17:59:00',
      color: '#fadbf8',
      featured: ['escoffier', 'navia'],
      featuredRare: ['ifa', 'ororon', 'layla'],
      version: '5.6',
      timezoneDependent: true,
    },
  ],
  'Seeker of Flame-Wrought Secrets 2': [
    {
      name: 'Seeker of Flame-Wrought Secrets',
      image: 2,
      shortName: 'Kinich',
      start: '2025-05-27 18:00:00',
      end: '2025-06-17 14:59:00',
      color: '#53dcb9',
      featured: ['kinich', 'raiden_shogun'],
      featuredRare: ['thoma', 'kujou_sara', 'lynette'],
      version: '5.6',
    },
    {
      name: 'Reign of Serenity',
      image: 6,
      shortName: 'Raiden',
      start: '2025-05-27 18:00:00',
      end: '2025-06-17 14:59:00',
      color: '#53dcb9',
      featured: ['kinich', 'raiden_shogun'],
      featuredRare: ['thoma', 'kujou_sara', 'lynette'],
      version: '5.6',
    },
  ],
  "Void Star's Advent 1": [
    {
      name: "Void Star's Advent",
      image: 1,
      shortName: 'Skirk',
      start: '2025-06-18 06:00:00',
      end: '2025-07-08 17:59:00',
      color: '#adcdff',
      featured: ['skirk', 'shenhe'],
      featuredRare: ['dahlia', 'candace', 'diona'],
      timezoneDependent: true,
      version: '5.7',
    },
    {
      name: 'The Transcendent One Returns',
      image: 3,
      shortName: 'Shenhe',
      start: '2025-06-18 06:00:00',
      end: '2025-07-08 17:59:00',
      color: '#adcdff',
      featured: ['skirk', 'shenhe'],
      featuredRare: ['dahlia', 'candace', 'diona'],
      timezoneDependent: true,
      version: '5.7',
    },
  ],
  'Ancient Flame Ablaze 2': [
    {
      name: 'Ancient Flame Ablaze',
      image: 2,
      shortName: 'Mavuika',
      start: '2025-07-08 18:00:00',
      end: '2025-07-29 14:59:00',
      color: '#ff6b37',
      featured: ['mavuika', 'emilie'],
      featuredRare: ['iansan', 'yaoyao', 'xiangling'],
      version: '5.7',
    },
    {
      name: 'Ambrosial Essence',
      image: 2,
      shortName: 'Emilie',
      start: '2025-07-08 18:00:00',
      end: '2025-07-29 14:59:00',
      color: '#cde8a4',
      featured: ['mavuika', 'emilie'],
      featuredRare: ['iansan', 'yaoyao', 'xiangling'],
      version: '5.7',
    },
  ],
  'Astral Actuation 1': [
    {
      name: 'Astral Actuation',
      image: 1,
      shortName: 'Ineffa',
      start: '2025-07-30 06:00:00',
      end: '2025-08-19 17:59:00',
      color: '#e3ffff',
      featured: ['ineffa', 'citlali'],
      featuredRare: ['sethos', 'xingqiu', 'fischl'],
      version: '5.8',
      timezoneDependent: true,
    },
    {
      name: "Starry Night's Whispers",
      image: 2,
      shortName: 'Citlali',
      start: '2025-07-30 06:00:00',
      end: '2025-08-19 17:59:00',
      color: '#efcbe5',
      featured: ['ineffa', 'citlali'],
      featuredRare: ['sethos', 'xingqiu', 'fischl'],
      version: '5.8',
      timezoneDependent: true,
    },
  ],
  'Sharktacular Surfari 2': [
    {
      name: 'Sharktacular Surfari',
      image: 2,
      shortName: 'Mualani',
      start: '2025-08-19 18:00:00',
      end: '2025-09-09 14:59:00',
      color: '#6fc5e2',
      featured: ['mualani', 'chasca'],
      featuredRare: ['ifa', 'ororon', 'bennett'],
      version: '5.8',
    },
    {
      name: "Piercing Shot's Crimson Wake",
      image: 2,
      shortName: 'Chasca',
      start: '2025-08-19 18:00:00',
      end: '2025-09-09 14:59:00',
      color: '#6fc5e2',
      featured: ['mualani', 'chasca'],
      featuredRare: ['ifa', 'ororon', 'bennett'],
      version: '5.8',
    },
  ],
  'Moonsong of the Groves 1': [
    {
      name: 'Moonsong of the Groves',
      image: 1,
      shortName: 'Lauma',
      start: '2025-09-10 06:00:00',
      end: '2025-09-30 17:59:00',
      color: '#d7f0f3',
      featured: ['lauma', 'nahida'],
      featuredRare: ['barbara', 'kuki_shinobu', 'kaveh'],
      version: '6.0',
      timezoneDependent: true,
    },
    {
      name: "The Moongrass' Enlightenment",
      image: 5,
      shortName: 'Nahida',
      start: '2025-09-10 06:00:00',
      end: '2025-09-30 17:59:00',
      color: '#b8db94',
      featured: ['lauma', 'nahida'],
      featuredRare: ['barbara', 'kuki_shinobu', 'kaveh'],
      version: '6.0',
      timezoneDependent: true,
    },
  ],
  'The Lone Light Knocks at Night 1': [
    {
      name: 'The Lone Light Knocks at Night',
      image: 1,
      shortName: 'Flins',
      start: '2025-09-30 18:00:00',
      end: '2025-10-21 17:59:00',
      color: '#84a3fb',
      featured: ['flins', 'yelan'],
      featuredRare: ['aino', 'sucrose', 'dori'],
      version: '6.0',
    },
    {
      name: 'Discerner of Enigmas',
      image: 5,
      shortName: 'Yelan',
      start: '2025-09-30 18:00:00',
      end: '2025-10-21 17:59:00',
      color: '#84a3fb',
      featured: ['flins', 'yelan'],
      featuredRare: ['aino', 'sucrose', 'dori'],
      version: '6.0',
    },
  ],
  'Temptation of the Crimson Sands 1': [
    {
      name: 'Temptation of the Crimson Sands',
      image: 1,
      shortName: 'Nefer',
      start: '2025-10-22 06:00:00',
      end: '2025-11-11 17:59:00',
      color: '#2dd891',
      featured: ['nefer', 'furina'],
      featuredRare: ['xingqiu', 'collei', 'yaoyao'],
      version: '6.1',
      timezoneDependent: true,
    },
    {
      name: 'Chanson of Many Waters',
      image: 4,
      shortName: 'Furina',
      start: '2025-10-22 06:00:00',
      end: '2025-11-11 17:59:00',
      color: '#95d6fb',
      featured: ['nefer', 'furina'],
      featuredRare: ['xingqiu', 'collei', 'yaoyao'],
      version: '6.1',
      timezoneDependent: true,
    },
  ],
  "The Hearth's Ashen Shadow 3": [
    {
      name: "The Hearth's Ashen Shadow",
      image: 3,
      shortName: 'Arlecchino',
      start: '2025-11-11 18:00:00',
      end: '2025-12-02 14:59:00',
      color: '#f8f8f8',
      featured: ['arlecchino', 'zhongli'],
      featuredRare: ['lan_yan', 'rosaria', 'yun_jin'],
      version: '6.1',
    },
    {
      name: 'Gentry of Hermitage',
      image: 7,
      shortName: 'Zhongli',
      start: '2025-11-11 18:00:00',
      end: '2025-12-02 14:59:00',
      color: '#D1A55C',
      featured: ['arlecchino', 'zhongli'],
      featuredRare: ['lan_yan', 'rosaria', 'yun_jin'],
      version: '6.1',
    },
  ],
  'Rubedo, of White Stone Born 1': [
    {
      name: 'Rubedo, of White Stone Born',
      image: 1,
      shortName: 'Durin',
      start: '2025-12-03 06:00:00',
      end: '2025-12-23 17:59:00',
      color: '#e9c8ec',
      featured: ['durin', 'venti'],
      featuredRare: ['bennett', 'faruzan', 'jahoda'],
      version: '6.2',
      timezoneDependent: true,
    },
    {
      name: 'Ballad in Goblets',
      image: 7,
      shortName: 'Venti',
      start: '2025-12-03 06:00:00',
      end: '2025-12-23 17:59:00',
      color: '#96f6de',
      featured: ['durin', 'venti'],
      featuredRare: ['bennett', 'faruzan', 'jahoda'],
      version: '6.2',
      timezoneDependent: true,
    },
  ],
  'Cornucopia of Contention 2': [
    {
      name: 'Cornucopia of Contention',
      image: 2,
      shortName: 'Varesa',
      start: '2025-12-23 18:00:00',
      end: '2026-01-13 14:59:00',
      color: '#ffa3af',
      featured: ['varesa', 'xilonen'],
      featuredRare: ['iansan', 'chevreuse', 'gaming'],
      version: '6.2',
    },
    {
      name: "Forgefire's Blessing",
      image: 3,
      shortName: 'Xilonen',
      start: '2025-12-23 18:00:00',
      end: '2026-01-13 14:59:00',
      color: '#fae3a4',
      featured: ['varesa', 'xilonen'],
      featuredRare: ['iansan', 'chevreuse', 'gaming'],
      version: '6.2',
    },
  ],
  'Somnias a Luna 1': [
    {
      name: 'Somnias a Luna',
      image: 1,
      shortName: 'Columbina',
      start: '2026-01-14 06:00:00',
      end: '2026-02-03 17:59:00',
      color: '#ddeafd',
      featured: ['columbina', 'ineffa'],
      featuredRare: ['fischl', 'sethos', 'ifa'],
      version: '6.3',
      timezoneDependent: true,
    },
    {
      name: 'Astral Actuation',
      image: 2,
      shortName: 'Ineffa',
      start: '2026-01-14 06:00:00',
      end: '2026-02-03 17:59:00',
      color: '#e3ffff',
      featured: ['columbina', 'ineffa'],
      featuredRare: ['fischl', 'sethos', 'ifa'],
      version: '6.3',
      timezoneDependent: true,
    },
  ],
  'Harmonious Abundance 1': [
    {
      name: 'Harmonious Abundance',
      image: 1,
      shortName: 'Zibai',
      start: '2026-02-03 18:00:00',
      end: '2026-02-24 14:59:00',
      color: '#ddeafd',
      featured: ['zibai', 'neuvillette'],
      featuredRare: ['illuga', 'aino', 'gorou'],
      version: '6.3',
    },
    {
      name: 'Decree of the Deeps',
      image: 4,
      shortName: 'Neuvillette',
      start: '2026-02-03 18:00:00',
      end: '2026-02-24 14:59:00',
      color: '#ddeafd',
      featured: ['zibai', 'neuvillette'],
      featuredRare: ['illuga', 'aino', 'gorou'],
      version: '6.3',
    },
  ],
  "The Northerly Wind's Song of Triumph 1": [
    {
      name: "The Northerly Wind's Song of Triumph",
      image: 1,
      shortName: 'Varka',
      start: '2026-02-25 06:00:00',
      end: '2026-03-17 17:59:00',
      color: '#47c2d5',
      featured: ['varka', 'flins'],
      featuredRare: ['bennett', 'xiangling', 'sucrose'],
      version: '6.4',
      timezoneDependent: true,
    },
    {
      name: 'The Lone Light Knocks at Night',
      image: 2,
      shortName: 'Flins',
      start: '2026-02-25 06:00:00',
      end: '2026-03-17 17:59:00',
      color: '#47c2d5',
      featured: ['varka', 'flins'],
      featuredRare: ['bennett', 'xiangling', 'sucrose'],
      version: '6.4',
      timezoneDependent: true,
    },
  ],
  "Void Star's Advent 2": [
    {
      name: "Void Star's Advent",
      image: 2,
      shortName: 'Skirk',
      start: '2026-03-17 18:00:00',
      end: '2026-04-07 14:59:00',
      color: '#adcdff',
      featured: ['skirk', 'escoffier'],
      featuredRare: ['dahlia', 'candace', 'charlotte'],
      version: '6.4',
    },
    {
      name: 'La Chanson Cerise',
      image: 2,
      shortName: 'Escoffier',
      start: '2026-03-17 18:00:00',
      end: '2026-04-07 14:59:00',
      color: '#7af8fd',
      featured: ['skirk', 'escoffier'],
      featuredRare: ['dahlia', 'candace', 'charlotte'],
      version: '6.4',
    },
  ],
  'Ya-hoho! Compendium 1': [
    {
      name: 'Ya-hoho! Compendium',
      image: 1,
      shortName: 'Linnea',
      start: '2026-04-08 06:00:00',
      end: '2026-04-28 17:59:00',
      color: '#fcdcd0',
      featured: ['linnea', 'chasca'],
      featuredRare: ['illuga', 'aino', 'noelle'],
      version: '6.5',
      timezoneDependent: true,
    },
    {
      name: "Piercing Shot's Crimson Wake",
      image: 3,
      shortName: 'Chasca',
      start: '2026-04-08 06:00:00',
      end: '2026-04-28 17:59:00',
      color: '#fcdcd0',
      featured: ['linnea', 'chasca'],
      featuredRare: ['illuga', 'aino', 'noelle'],
      version: '6.5',
      timezoneDependent: true,
    },
  ],
  'Moonsong of the Groves 2': [
    {
      name: 'Moonsong of the Groves',
      image: 2,
      shortName: 'Lauma',
      start: '2026-04-28 18:00:00',
      end: '2026-05-19 14:59:00',
      color: '#d7f0f3',
      featured: ['lauma', 'nefer'],
      featuredRare: ['xingqiu', 'kirara', 'jahoda'],
      version: '6.5',
    },
    {
      name: 'Temptation of the Crimson Sands',
      image: 2,
      shortName: 'Nefer',
      start: '2026-04-28 18:00:00',
      end: '2026-05-19 14:59:00',
      color: '#fcdcd0',
      featured: ['lauma', 'nefer'],
      featuredRare: ['xingqiu', 'kirara', 'jahoda'],
      version: '6.5',
    },
  ],
  "Angel's Reverie 1": [
    {
      name: "Angel's Reverie",
      image: 1,
      shortName: 'Nicole',
      start: '2026-05-20 06:00:00',
      end: '2026-06-09 17:59:00',
      color: '#fef4ca',
      featured: ['nicole', 'durin'],
      featuredRare: ['prune', 'fischl', 'razor'],
      version: '6.6',
      timezoneDependent: true,
    },
    {
      name: 'Rubedo, of White Stone Born',
      image: 2,
      shortName: 'Durin',
      start: '2026-05-20 06:00:00',
      end: '2026-06-09 17:59:00',
      color: '#e9c8ec',
      featured: ['nicole', 'durin'],
      featuredRare: ['prune', 'fischl', 'razor'],
      version: '6.6',
      timezoneDependent: true,
    },
  ],
  'Frostedge Nocturne 1': [
    {
      name: 'Frostedge Nocturne',
      image: 1,
      shortName: 'Lohen',
      start: '2026-06-09 18:00:00',
      end: '2026-06-30 14:59:00',
      color: '#efe8e6',
      featured: ['lohen', 'mavuika'],
      featuredRare: ['mika', 'xiangling', 'bennett'],
      version: '6.6',
    },
    {
      name: 'Ancient Flame Ablaze',
      image: 3,
      shortName: 'Mavuika',
      start: '2026-06-09 18:00:00',
      end: '2026-06-30 14:59:00',
      color: '#ff6b37',
      featured: ['lohen', 'mavuika'],
      featuredRare: ['mika', 'xiangling', 'bennett'],
      version: '6.6',
    },
  ],
  'To the Looking-Glass the Mademoiselle Said 1': [
    {
      name: 'To the Looking-Glass the Mademoiselle Said',
      image: 1,
      shortName: 'Sandrone',
      start: '2026-07-01 06:00:00',
      end: '2026-07-21 17:59:00',
      color: '#feeedd',
      featured: ['sandrone', 'citlali'],
      featuredRare: ['beidou', 'diona', 'freminet'],
      version: '6.7',
      timezoneDependent: true,
    },
    {
      name: "Starry Night's Whispers",
      image: 3,
      shortName: 'Sandrone',
      start: '2026-07-01 06:00:00',
      end: '2026-07-21 17:59:00',
      color: '#efcbe5',
      featured: ['sandrone', 'citlali'],
      featuredRare: ['beidou', 'diona', 'freminet'],
      version: '6.7',
      timezoneDependent: true,
    },
  ],
  'Somnias a Luna 2': [
    {
      name: 'Somnias a Luna',
      image: 2,
      shortName: 'Columbina',
      start: '2026-07-21 18:00:00',
      end: '2026-08-11 14:59:00',
      color: '#ddeafd',
      featured: ['columbina', 'raiden_shogun'],
      featuredRare: ['jahoda', 'ororon', 'sethos'],
      version: '6.7',
    },
    {
      name: 'Reign of Serenity',
      image: 7,
      shortName: 'Raiden Shogun',
      start: '2026-07-21 18:00:00',
      end: '2026-08-11 14:59:00',
      color: '#53dcb9',
      featured: ['columbina', 'raiden_shogun'],
      featuredRare: ['jahoda', 'ororon', 'sethos'],
      version: '6.7',
    },
  ],
  "Swan's Shadow in Silken Ice 1": [
    {
      name: "Swan's Shadow in Silken Ice",
      image: 1,
      shortName: 'Odette',
      start: '2026-08-12 06:00:00',
      end: '2026-09-01 17:59:00',
      color: '#ffffff',
      featured: ['odette', 'arlecchino'],
      featuredRare: ['alyosha', 'sucrose', 'lynette'],
      version: '7.0',
      timezoneDependent: true,
    },
    {
      name: "The Hearth's Ashen Shadow",
      image: 4,
      shortName: 'Arlecchino',
      start: '2026-08-12 06:00:00',
      end: '2026-09-01 17:59:00',
      color: '#ffffff',
      featured: ['odette', 'arlecchino'],
      featuredRare: ['alyosha', 'sucrose', 'lynette'],
      version: '7.0',
      timezoneDependent: true,
    },
  ],
  'The Lone Light Knocks at Night 3': [
    {
      name: 'The Lone Light Knocks at Night',
      image: 3,
      shortName: 'Flins',
      start: '2026-09-01 18:00:00',
      end: '2026-09-22 14:59:00',
      color: '#47c2d5',
      featured: ['flins', 'ineffa'],
      featuredRare: ['aino', 'iansan', 'lan_yan'],
      version: '7.0',
    },
    {
      name: 'Astral Actuation',
      image: 3,
      shortName: 'Ineffa',
      start: '2026-09-01 18:00:00',
      end: '2026-09-22 14:59:00',
      color: '#e3ffff',
      featured: ['flins', 'ineffa'],
      featuredRare: ['aino', 'iansan', 'lan_yan'],
      version: '7.0',
    },
  ],
  'When Warm Winds Cavort 1': [
    {
      name: 'When Warm Winds Cavort',
      image: 1,
      shortName: 'Vesna',
      start: '2026-09-23 06:00:00',
      end: '2026-10-13 17:59:59',
      color: '#8dd6d9',
      featured: ['vesna', 'vodyanitsa'],
      featuredRare: ['diona', 'faruzan', 'chongyun'],
      version: '7.1',
      timezoneDependent: true,
    },
    {
      name: 'Surging Ballad',
      image: 1,
      shortName: 'Vodyanitsa',
      start: '2026-09-23 06:00:00',
      end: '2026-10-13 17:59:59',
      color: '#65cad7',
      featured: ['vesna', 'vodyanitsa'],
      featuredRare: ['diona', 'faruzan', 'chongyun'],
      version: '7.1',
      timezoneDependent: true,
    },
  ],
  "Void Star's Advent 3": [
    {
      name: "Void Star's Advent",
      image: 3,
      shortName: 'Skirk',
      start: '2026-10-13 18:00:00',
      end: '2026-11-03 14:59:59',
      color: '#adcdff',
      featured: ['skirk', 'escoffier'],
      featuredRare: ['dahlia', 'candace', 'mika'],
      version: '7.1',
    },
    {
      name: 'La Chanson Cerise',
      image: 3,
      shortName: 'Escoffier ',
      start: '2026-10-13 18:00:00',
      end: '2026-11-03 14:59:59',
      color: '#7af8fd',
      featured: ['skirk', 'escoffier'],
      featuredRare: ['dahlia', 'candace', 'mika'],
      version: '7.1',
    },
  ],
};
